import { spanFromRegExpMatch } from '../spans';
import type { ExtractorOutput } from './types';

/**
 * Bedroom / bathroom / parking count extractors.
 * Beds accept `bd` in addition to bed(s)/br (fixes "3bd house").
 */
export function extractBedrooms(query: string): ExtractorOutput {
  const pattern = /(\d+)\s*\+?\s*(?:bedrooms?|beds?|bd|br)\b/gi;
  const match = pattern.exec(query);
  if (!match) return { partial: {}, spans: [] };

  const isExact = /\bexactly\b/i.test(query);
  const value = isExact ? match[1] : `${match[1]}+`;
  return {
    partial: { bedrooms: value },
    spans: [
      spanFromRegExpMatch(query, match, 'bedrooms', value, {
        confidence: 0.95,
        ruleId: 'bedrooms.count',
        includeExactly: isExact,
      }),
    ],
  };
}

export function extractBathrooms(query: string): ExtractorOutput {
  const pattern = /(\d+)\s*\+?\s*(?:bathrooms?|baths?|ba)\b/gi;
  const match = pattern.exec(query);
  if (!match) return { partial: {}, spans: [] };

  const isExact = /\bexactly\b/i.test(query);
  const value = isExact ? match[1] : `${match[1]}+`;
  return {
    partial: { bathrooms: value },
    spans: [
      spanFromRegExpMatch(query, match, 'bathrooms', value, {
        confidence: 0.95,
        ruleId: 'bathrooms.count',
        includeExactly: isExact,
      }),
    ],
  };
}

export function extractParkingSpaces(query: string): ExtractorOutput {
  const pattern = /(\d+)\s*\+?\s*(?:parking\s+spaces?|parking\s+spots?|car\s+garages?)\b/gi;
  const match = pattern.exec(query);
  if (!match) return { partial: {}, spans: [] };

  const isExact = /\bexactly\b/i.test(query);
  const value = isExact ? match[1] : `${match[1]}+`;
  return {
    partial: { parkingSpaces: value },
    spans: [
      spanFromRegExpMatch(query, match, 'parkingSpaces', value, {
        confidence: 0.9,
        ruleId: 'parkingSpaces.count',
        includeExactly: isExact,
      }),
    ],
  };
}
